import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';
import { v4 as uuidv4 } from 'uuid';
import { connect, useDispatch } from 'react-redux';
import { useCallback, useMemo, useState } from 'react';
import { FormSpy } from 'react-final-form';
import { Dispatch } from 'redux';
import { ValueOfRecord } from 'ramda';

import { IKnmErknmFormObject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';
import { OBJECTS_BLOCK_ID } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { Button } from 'UIPackage/MainModule/components/Button';
import { KNM_OBJECTS_INFO } from 'CorePackage/MainModule/routes/routes';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { IDangerClass248 } from 'APIPackage/DictionariesModule/interfaces/IDangerClass248';
import { IRiskCategory248 } from 'APIPackage/DictionariesModule/interfaces/IRiskCategory248';
import { ISubjectKind } from 'APIPackage/DictionariesModule/interfaces/ISubjectKind';
import { ISubjectType } from 'APIPackage/DictionariesModule/interfaces/ISubjectType';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import {
  getDecisionDangerClassesSelectOptions,
  getDecisionFormRef,
  getDecisionKnoSupervisionHazardClassApplies,
  getDecisionSubjectKindsSelectOptions,
  getDecisionSubjectSubKindsSelectOptions,
  getDecisionSubjectTypesSelectOptions,
  getDecisionTargetEntitySelectOptions,
  getDecisionIsCanRefreshControlObject,
  getDecisionKnoSupervisionUuid,
  getDecisionReasonsFormValue,
  getDecisionRiskCategoriesSelectOptions,
} from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { KnmErvkObjectsModal } from 'KnmPackage/KnmObjectsModule/components/KnmErvkObjectsModal';
import { IErvkObjectsOfControl } from 'APIPackage/KnmModule/interfaces/IErvkObjectsOfControl';
import { IErvkObjectsOfControlSubjectData } from 'APIPackage/KnmModule/interfaces/IErvkObjectsOfControlSubjectData';
import { IDecisionForm } from 'DecisionPackage/MainModule/interfaces/IDecisionForm';
import { INotification } from 'CorePackage/NotificationModule/interfaces/INotification';
import { addNoticeAction } from 'CorePackage/NotificationModule/actions/NoticeActions';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { ITargetEntity } from 'APIPackage/DictionariesModule/interfaces/ITargetEntity';
import { NoticeTypesEnum } from 'CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from 'CorePackage/NotificationModule/enums/MessageTypesEnum';
import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { getAdminFetchSettings } from 'PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IDecisionFormReason } from 'DecisionPackage/MainModule/interfaces/IDecisionFormReason';
import { findRegionSelectOption } from 'KnmPackage/MainModule/components/regions';
import { ICommonFormRef } from 'KnmErknmPackage/MainModule/interfaces/ICommonFormRef';
import { IDictionarySubjectTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySubjectTypeSelectOption';
import {
  dictionariesSubjectKindsItemGet,
  dictionariesSubjectSubKindsItemGet,
} from 'CorePackage/DictionariesModule/actions/dictionariesActions';
import { KnmReasonTypeNameEnum } from 'KnmPackage/MainModule/enums/KnmReasonTypeNameEnum';

import { KnmObjectItem } from '../../../KnmPackage/KnmObjectsModule/components/KnmObjectItem';
import { mapSubjectTypeCodeToName } from '../../../KnmPackage/KnmObjectsModule/common/mapSubjectTypeCodeToName';
import { addObject } from '../../../KnmPackage/KnmObjectsModule/common/addObject';
import { addErvkObject } from '../../../KnmPackage/KnmObjectsModule/common/addErvkObject';
import { getObjectBlockId } from '../../../KnmPackage/MainModule/constants/fieldsElementsIds';
import { ICountrySelectOption } from '../../../CorePackage/CatalogsModule/interfaces/ICountrySelectOption';
import {
  getCountriesSelectOptions,
  getDistrictSelectOptions,
} from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { KnmSubjectTypesEnum } from '../../../KnmErknmPackage/ErknmSubjectModule/components/ErknmSubjectInfo';
import { getTitleFieldWithRedStar } from '../../../functions/getTitleFieldWithRedStar';
import { IKnmDistrictSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmDistrictSelectOption';
import { useDecisionErknmSubjectFields } from '../hooks/useDecisionErknmSubjectFields';
import { IDecisionOrganizationForm } from '../../MainModule/interfaces/IDecisionOrganizationForm';

interface IDecisionObjectsProps {
  created: string | undefined;
  isPassportByCheckPrescriptionOldRules: boolean;
  isWatchOnly: boolean;
  organization: IDecisionOrganizationForm | undefined;
  reasons: IDecisionFormReason[] | undefined;
}

interface IDecisionObjectsStoreProps {
  countriesSelectOptions: ICountrySelectOption[] | undefined;
  dangerClassesSelectOptions: IDictionarySelectOption<IDangerClass248>[] | undefined;
  districtSelectOptions: IKnmDistrictSelectOption[];
  formRef: IDecisionFormRef | undefined;
  hazardClassApplies: boolean | undefined;
  isCanRefreshControlObject?: boolean | undefined;
  knoSupervisionUuid?: string;
  objectKindsSelectOptions: IDictionarySelectOption<ISubjectKind>[] | undefined;
  objectSubKindsSelectOptions: IDictionarySelectOption<ISubjectKind>[] | undefined;
  objectTypesSelectOptions: IDictionarySelectOption<ISubjectType>[] | undefined;
  orderVersionId?: string;
  reasonUuid?: string;
  riskCategoriesSelectOptions: IDictionarySelectOption<IRiskCategory248>[] | undefined;
  settings: IAdminSetting[] | undefined;
  targetEntitySelectOptions?: IDictionarySelectOption<ITargetEntity>[];
}

const DecisionObjectsWithoutStore = ({
  created,
  isPassportByCheckPrescriptionOldRules,
  isWatchOnly,
  organization,
  reasons,
  countriesSelectOptions,
  dangerClassesSelectOptions,
  districtSelectOptions,
  formRef,
  hazardClassApplies,
  isCanRefreshControlObject,
  knoSupervisionUuid,
  objectKindsSelectOptions,
  objectSubKindsSelectOptions,
  objectTypesSelectOptions,
  orderVersionId,
  reasonUuid,
  riskCategoriesSelectOptions,
  settings,
  targetEntitySelectOptions,
}: IDecisionObjectsProps & IDecisionObjectsStoreProps) => {
  const push = formRef?.current.mutators.push;
  const remove = formRef?.current.mutators.remove;
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const change = formRef ? (formRef?.current.change as ICommonFormRef['current']['change']) : () => {};
  const getFieldState = formRef
    ? (formRef?.current.getFieldState as ICommonFormRef['current']['getFieldState'])
    : () => {};
  const subjectFieldNames = useDecisionErknmSubjectFields({ name: 'organization' });

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const openModal = useCallback(() => {
    setIsModalVisible(true);
  }, []);
  const closeModal = () => {
    setIsModalVisible(false);
  };

  const addNotice: (notice: INotification) => void = useCallback(
    (notice: INotification) => dispatch(addNoticeAction(notice)),
    [dispatch],
  );

  const isUseOnlyLowRiskInManualObject = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_223_4_1_42_STARTS_FROM,
  );

  /**
   * Элемент "низкий риск"
   */
  const lowRisk = useMemo(() => {
    if (hazardClassApplies) {
      return dangerClassesSelectOptions?.find(risk => risk.code === '6');
    }

    return riskCategoriesSelectOptions?.find(risk => risk.code === '6');
  }, [hazardClassApplies, dangerClassesSelectOptions, riskCategoriesSelectOptions]);

  /**
   * Переменная, отвечающая за блокировку кнопки "Добавить вручную"
   */
  const isDisabledButtonAddManual = useMemo(() => {
    return isWatchOnly || (isUseOnlyLowRiskInManualObject && !lowRisk);
  }, [isWatchOnly, isUseOnlyLowRiskInManualObject, lowRisk]);

  const addKnmObject = useCallback(() => {
    addObject(isWatchOnly, push, 'objects', isUseOnlyLowRiskInManualObject && lowRisk ? lowRisk : undefined);
  }, [push, isWatchOnly, isUseOnlyLowRiskInManualObject, lowRisk]);

  const addFromErvk = useCallback(
    (ervkObjects: IErvkObjectsOfControl[], subjects: IErvkObjectsOfControlSubjectData[]) => {
      if (!isWatchOnly && push) {
        let id;

        const isNewFieldName = 'isOrganizationNew' as keyof IDecisionForm;

        subjects.forEach(async subject => {
          const isSubjectAddressInFias = subject.locationIsFromFias;
          const currentSubject = formRef?.current.getFieldState(isNewFieldName)?.value;
          const isSubjectExistException = () => {
            if (currentSubject) {
              const currentSubjectInn = getFieldState(subjectFieldNames.inn)?.value;
              const currentSubjectOgrn = getFieldState(subjectFieldNames.ogrn)?.value;
              const currentSubjectSnils = getFieldState(subjectFieldNames.snils)?.value;

              return !(
                (currentSubjectInn && currentSubjectInn === subject?.inn) ||
                (currentSubjectOgrn && currentSubjectOgrn === subject?.ogrn) ||
                (currentSubjectSnils && currentSubjectSnils === subject?.snils)
              );
            }

            return false;
          };
          const subjectTypeCode = mapSubjectTypeCodeToName(subject.subjectType);
          const isFIZ = subjectTypeCode === KnmSubjectTypesEnum.FIZ;
          const isIFIZ = subjectTypeCode === KnmSubjectTypesEnum.IFIZ;
          const isIP = subjectTypeCode === KnmSubjectTypesEnum.IP;

          const searchSubjectRegionId =
            subject.locationRegionFiasUuid || subject.locationRegionCode || subject.regionCode;

          const foundSubjectRegion = await findRegionSelectOption(
            subject.address,
            searchSubjectRegionId,
            districtSelectOptions,
          );

          if (isSubjectExistException()) {
            id = uuidv4();
          } else {
            if (currentSubject === undefined) {
              change(isNewFieldName, true);
              change(subjectFieldNames.locationnotInFIAS, !isSubjectAddressInFias);
              change(subjectFieldNames.locationregion, foundSubjectRegion);
              change(subjectFieldNames.locationfiasRegion, foundSubjectRegion);
              change(subjectFieldNames.inn, subject?.inn);
              change(subjectFieldNames.ogrn, subject?.ogrn);
              change(
                subjectFieldNames.originalName,
                isFIZ || isIFIZ || isIP
                  ? `${subject.surName} ${subject.firstName} ${subject.middleName}`
                  : subject?.organizationFullName,
              );
              change(
                subjectFieldNames.organizationType,
                targetEntitySelectOptions?.find(
                  x => x.label === mapSubjectTypeCodeToName(subject?.subjectType),
                ) as ValueOfRecord<IDecisionForm>,
              );
              change(subjectFieldNames.rafpNza, subject?.rafp);
              change(subjectFieldNames.kpp, subject?.kpp);
              change(subjectFieldNames.snils, subject?.snils);
              change(subjectFieldNames.locationAddress, !isIP ? subject?.address : undefined);
              change(subjectFieldNames.factualAddress, isIP ? subject.address : undefined);
              change(subjectFieldNames.ervkId, subject?.id);
              change(subjectFieldNames.document, subject?.identityDocumentNumber);
              if (subject?.nationality) {
                change(
                  subjectFieldNames.country,
                  countriesSelectOptions?.find(c => c.title === subject.nationality) as ValueOfRecord<IDecisionForm>,
                );
              }
            }

            const relatedObjects = ervkObjects.filter(x => x.subjects.filter(s => s.inn === subject.inn)?.length);

            relatedObjects.forEach(object => {
              addErvkObject(
                object,
                subject?.id,
                dangerClassesSelectOptions,
                objectKindsSelectOptions,
                objectSubKindsSelectOptions,
                objectTypesSelectOptions,
                riskCategoriesSelectOptions,
                districtSelectOptions,
                push,
                'objects',
              );
            });
          }
        });

        if (id) {
          addNotice({
            renderContent: <>В паспорт можно добавить сведения только об одном контролируемом лице</>,
            noticeType: NoticeTypesEnum.ERROR,
            messageType: MessageTypesEnum.DELETE_REQUIREMENT,
            id,
          });
        } else {
          closeModal();
        }
      }
    },
    [
      change,
      push,
      isWatchOnly,
      objectTypesSelectOptions,
      objectKindsSelectOptions,
      objectSubKindsSelectOptions,
      riskCategoriesSelectOptions,
      dangerClassesSelectOptions,
      districtSelectOptions,
    ],
  );

  const makeRemoveKnmObjectHandler = (index: number, organizationErvkIds: string[] | null | undefined) => () => {
    if (isWatchOnly || !remove) {
      return;
    }

    const organizationErvkId = formRef?.current.getFieldState('organization')?.value?.ervkId;
    const objects = formRef?.current.getFieldState('objects')?.value;
    const isLastObjectOfOrganization =
      !!organizationErvkId &&
      !!organizationErvkIds?.includes(organizationErvkId) &&
      objects?.filter(obj => obj.organizationErvkId?.includes(organizationErvkId))?.length === 1;

    if (isLastObjectOfOrganization) {
      change('organization');
      change('isOrganizationNew');
    }

    remove('objects', index);
  };

  /**
   * Обработчик изменения какого либо типа объекта
   */
  const onChangeObjectTypeChange = useCallback(
    (option: IDictionarySubjectTypeSelectOption) => {
      if (option && option?.value?.dictVersionId) {
        if (knoSupervisionUuid) {
          if (reasonUuid || orderVersionId) {
            dispatch(
              dictionariesSubjectKindsItemGet(
                knoSupervisionUuid,
                reasonUuid,
                orderVersionId,
                option?.value?.dictVersionId,
              ),
            );
            dispatch(
              dictionariesSubjectSubKindsItemGet(
                knoSupervisionUuid,
                reasonUuid,
                orderVersionId,
                option?.value?.dictVersionId,
              ),
            );
          } else {
            dispatch(
              dictionariesSubjectKindsItemGet(knoSupervisionUuid, undefined, undefined, option?.value?.dictVersionId),
            );
            dispatch(
              dictionariesSubjectSubKindsItemGet(
                knoSupervisionUuid,
                undefined,
                undefined,
                option?.value?.dictVersionId,
              ),
            );
          }
        }
      }
    },
    [formRef, dispatch, knoSupervisionUuid, orderVersionId, reasonUuid],
  );

  const isFilledFromPrescriptionLink =
    reasons?.[0]?.type?.name === KnmReasonTypeNameEnum.PRESCRIPTION_CHECK && !isPassportByCheckPrescriptionOldRules;

  return (
    <FieldBlock
      label={getTitleFieldWithRedStar({
        label: 'Сведения об объектах контроля',
        field: `objects`,
        isDecision: true,
      })}
      id={KNM_OBJECTS_INFO}
      labelId={OBJECTS_BLOCK_ID}
      margin="top"
      labelFontSize="medium"
      color="black"
      button={
        !isFilledFromPrescriptionLink && (
          <>
            <Button
              className="shared-btn-add"
              text="Добавить объект из ЕРВК"
              type="button"
              variant="link"
              color="primary"
              id="erknmObjectsAddButton"
              disabled={isWatchOnly}
              onClick={openModal}
            />
            {!lowRisk && isUseOnlyLowRiskInManualObject ? (
              <Tooltip
                placement="top"
                type="info"
                content={
                  <div className="shared-tooltip-info-content" style={{ width: '450px' }}>
                    Для выбранного вида контроля недоступны объекты с низкой категорией риска, которые добавляются
                    вручную
                  </div>
                }
              >
                <Button
                  className="shared-btn-add"
                  text="Добавить вручную"
                  type="button"
                  variant="link"
                  color="primary"
                  id="erknmObjectsAddButton"
                  disabled={isDisabledButtonAddManual}
                  onClick={addKnmObject}
                />
              </Tooltip>
            ) : (
              <Button
                className="shared-btn-add"
                text="Добавить вручную"
                type="button"
                variant="link"
                color="primary"
                id="erknmObjectsAddButton"
                disabled={isDisabledButtonAddManual}
                onClick={addKnmObject}
              />
            )}
          </>
        )
      }
    >
      <KnmErvkObjectsModal
        watchOnly={isWatchOnly}
        dangerClassesSelectOptions={hazardClassApplies ? dangerClassesSelectOptions : undefined}
        riskCategoriesSelectOptions={!hazardClassApplies ? riskCategoriesSelectOptions : undefined}
        onClose={closeModal}
        visible={isModalVisible}
        onSubmit={addFromErvk}
        kindKnmCode={undefined}
        isDecisionPassport
      />
      <FieldArray name="objects">
        {({ fields }: FieldArrayRenderProps<IKnmErknmFormObject, HTMLElement>) => {
          if (!fields.length) {
            return null;
          }

          return (
            <Row>
              {fields.map((name, index) => {
                const fieldValue: IKnmErknmFormObject = fields.value?.[index];
                const id = getObjectBlockId(fieldValue.listId);

                return (
                  <Row key={id} margin="medium" isListItem>
                    <KnmObjectItem
                      id={id}
                      isPm={false}
                      isErknm={false}
                      index={index}
                      hazardClassApplies={hazardClassApplies}
                      formRef={formRef}
                      name={name}
                      value={fieldValue}
                      objectTypesSelectOptions={objectTypesSelectOptions}
                      objectKindsSelectOptions={objectKindsSelectOptions}
                      objectSubKindsSelectOptions={objectSubKindsSelectOptions}
                      riskCategoriesSelectOptions={riskCategoriesSelectOptions}
                      dangerClassesSelectOptions={dangerClassesSelectOptions}
                      districtSelectOptions={districtSelectOptions}
                      countriesSelectOptions={countriesSelectOptions}
                      isCanRefreshControlObject={isCanRefreshControlObject}
                      objectTypeChangeCallback={onChangeObjectTypeChange}
                      objectKindSelectOptionsSelectorFunction={getDecisionSubjectKindsSelectOptions}
                      objectSubKindSelectOptionsSelectorFunction={getDecisionSubjectSubKindsSelectOptions}
                      isWatchOnly={isWatchOnly}
                      onRemove={makeRemoveKnmObjectHandler(index, fieldValue.organizationErvkId)}
                      created={created}
                      isFilledFromPrescriptionLink={isFilledFromPrescriptionLink}
                      reasonType={reasons?.[0]?.type}
                      decisionOrganization={organization}
                      isHasNonErvkOrganizations={!organization?.ervkId}
                      isRemoveAvailable={!isWatchOnly}
                    />
                  </Row>
                );
              })}
            </Row>
          );
        }}
      </FieldArray>
      <FormSpy subscription={{ errors: true, touched: true }}>
        {props => {
          if (props.touched?.objects && props?.errors?.objects && typeof props.errors?.objects?.[0] === 'string') {
            const fieldError = props.errors?.objects;
            const errorMessage: string | undefined = fieldError
              ? (Object.values(fieldError).reduce((prev: string, curr: string) => prev + curr, '') as string)
              : undefined;

            if (errorMessage) {
              return <p className="shared-input-error">{errorMessage}</p>;
            }
          }

          return null;
        }}
      </FormSpy>
    </FieldBlock>
  );
};

const mapStateToProps = (state: IRootState): IDecisionObjectsStoreProps => {
  const reasons = getDecisionReasonsFormValue(state);
  const reasonUuid = reasons?.map(x => x?.ervkUuid)?.find(uuid => uuid);
  const orderVersionId = reasons?.map(x => x?.order?.recordVersionId)?.find(uuid => uuid);

  return {
    countriesSelectOptions: getCountriesSelectOptions(state),
    dangerClassesSelectOptions: getDecisionDangerClassesSelectOptions(state),
    districtSelectOptions: getDistrictSelectOptions(state),
    formRef: getDecisionFormRef(state),
    hazardClassApplies: getDecisionKnoSupervisionHazardClassApplies(state),
    isCanRefreshControlObject: getDecisionIsCanRefreshControlObject(state),
    knoSupervisionUuid: getDecisionKnoSupervisionUuid(state),
    objectKindsSelectOptions: getDecisionSubjectKindsSelectOptions(state),
    objectSubKindsSelectOptions: getDecisionSubjectSubKindsSelectOptions(state),
    objectTypesSelectOptions: getDecisionSubjectTypesSelectOptions(state),
    orderVersionId,
    reasonUuid,
    riskCategoriesSelectOptions: getDecisionRiskCategoriesSelectOptions(state),
    settings: getAdminFetchSettings(state),
    targetEntitySelectOptions: getDecisionTargetEntitySelectOptions(state),
  };
};

export const DecisionObjects = connect(mapStateToProps)(DecisionObjectsWithoutStore);
